import {
  JobGetPartiesRequest,
  JobGetRateConfirmationRequest,
  type JobGetRequest,
  type JobServiceSearchRequest,
  type JobTypeSearchRequest,
} from '@trukt/tms-api';
import { createKey } from '../createKey';
import {
  JobCommodityServiceKeys,
  JobContractServiceKeys,
  JobDispatchCarrierServiceKeys,
  JobFinanceServiceKeys,
  JobPostServiceKeys,
} from './serviceKeys';

import { JobStatusServiceKeys } from '../JobStatusServiceKeys';
import { JobClassificationServiceKeys } from '../JobClassificationServiceKeys';

const keyHandler = createKey('job');

export const JobServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<JobServiceSearchRequest>(),
  getById: keyHandler.createMethod<JobGetRequest>(),
  classification: JobClassificationServiceKeys,
  finance: JobFinanceServiceKeys,
  contracts: JobContractServiceKeys,
  commodity: JobCommodityServiceKeys,
  post: JobPostServiceKeys,
  dispatch: {
    carrier: JobDispatchCarrierServiceKeys,
  },
  status: JobStatusServiceKeys,
  searchTypes: keyHandler.createMethod<JobTypeSearchRequest>(),
  getParties: keyHandler.createMethod<JobGetPartiesRequest>(),
  getStatusOptions: keyHandler.createMethod(),
  getRateConfirmation: keyHandler.createMethod<JobGetRateConfirmationRequest>(),
};
